import { render } from "./SortTableInstitutionCellComponent.vue?vue&type=template&id=23987cfb&scoped=true"
import script from "./SortTableInstitutionCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableInstitutionCellComponent.vue?vue&type=script&lang=js"

import "./SortTableInstitutionCellComponent.vue?vue&type=style&index=0&id=23987cfb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23987cfb"]])

export default __exports__